// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3wYcM","additionalInfo":"AgreementModal_additionalInfo__3cc4M"};